/* eslint-disable react/jsx-one-expression-per-line */
import { useEffect, useState } from 'react';
import CheckMark from '../../../isVegCheckMark/CheckMark';
import styles from './Reference.module.scss';
import { classes } from '../../../../Helpers';
import { Measurement } from '../Measurement';
import { Button } from '@/Components/ui/button';
import { useAuth } from '@/Components/Auth/Login/auth';

function Reference(props) {
	const {
		source,
		name,
		isVeg,
		brand,
		className,
		vendorName,
		fromStoreName,
		wastageDate,
		assetId,
		temp,
		weight,
		isRTV,
		// wastageReason,
		handleDelete = () => {},
		handleUpdate = () => {},
		isEdit = false,
		setIsEdit,
		pageType = '',
	} = props;

	const [updateValue, setUpdateValue] = useState('');
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const levels = [3, 4];
	const { userRolesDict = {} } = userConfig || {};
	const isInternal = Object?.values?.(userRolesDict ?? {}).includes('INTERNAL') || Object?.values?.(userRolesDict ?? {}).includes('Internal') || Object?.values?.(userRolesDict ?? {}).includes('Config Admin');

	const handleEdit = () => {
		setIsEdit((prev) => !prev);
	};
	useEffect(() => {
		setUpdateValue(weight?.piecesCount);
	}, [weight?.piecesCount]);

	const handleValue = (value) => {
		setUpdateValue(value);
	};

	return (
		<div className={classes(styles.root, className)}>
			<div className={styles.imageContainer}>
				{vendorName && (
					<div className={styles.vendor_name}>
						Vendor Name:
						{vendorName}
					</div>
				)}
				<img
					className={styles.image}
					src={source}
					alt='Food Reference'
				/>
				{isVeg != null && (
					<div className={styles.footer}>
						<img className={styles.brand} src={brand} alt='' />
						<CheckMark isVeg={isVeg} />
						<div className={styles['name-container']}>
							<p className={styles.name}>{name}</p>
							{assetId && <p>{assetId}</p>}
						</div>
					</div>
				)}
				<div className={styles.extraData}>
					{fromStoreName && (
						<div>
							From Outlet: <span> {fromStoreName} </span>
						</div>
					)}
					{wastageDate && (
						<div>
							Date: <span> {wastageDate}</span>
						</div>
					)}
				</div>
				{isRTV && (
					<div className={styles.rtv}>
						<p>This item was RETURNED to Vendor</p>
					</div>
				)}
				{pageType === 'productionHistory' && levels.includes(level) && isInternal && (
					<div className='flex justify-center items-center gap-2 w-full'>
						{isEdit ? (
							<Button
								onClick={() => handleUpdate(updateValue)}
								className='w-full bg-green-800 text-white hover:bg-green-600'
							>Save
							</Button>
						) : (
							<>
								{weight?.piecesCount && (
									<Button
										onClick={handleEdit}
										className='w-1/2 bg-blue-800 text-white hover:bg-blue-600'
									>Edit
									</Button>
								)}
								<Button
									onClick={handleDelete}
									className='w-1/2 bg-red-700 text-white hover:bg-red-500'
								>Delete
								</Button>
							</>
						)}
					</div>
				)}
				{/* {wastageReason &&
					(Array.isArray(wastageReason) ? (
						<>
							<div className={styles.reasonContainer}>
								{wastageReason?.map((reason) => {
									return (
										<p className={styles.reason}>
											Wastage Reason:
											{reason}
										</p>
									);
								})}
							</div>
						</>
					) : (
						<>
							<p className={styles.reason}>
								Wastage Reason:
								{wastageReason}
							</p>
						</>
					))} */}
				<Measurement
					className={styles.measurement}
					temp={temp}
					weight={weight}
					isEdit={isEdit}
					updateValue={updateValue}
					handleValue={handleValue}
				/>
			</div>
		</div>
	);
}

Reference.defaultProps = {
	source: '',
	name: '',
	isVeg: true,
	className: '',
};

export default Reference;
